// extracted by mini-css-extract-plugin
export default {"text":"fYqU6u"};